import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import Slider from 'react-rangeslider';

import { setOrtRadius, setOrtCategories } from '../../actions/actions';

import CategorySelect from '../../components/CategorySelect';

class EditOrt extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      radius: props.ort.radius || 20,
    };
  }
  setRadius = () => {
    this.props.setOrtRadius(this.props.ort.name, this.state.radius);
  };
  setCategories = value => {
    this.props.setOrtCategories(this.props.ort.name, value);
  };
  render() {
    const { ort } = this.props;

    if (!ort) return null;

    return (
      <div className="OrtDetail">
        <h2 className="OrtDetail-title">{ort.name}</h2>
        <p>In welchem Umkreis möchten Sie benachrichtigt werden?</p>
        <div className="OrtDetail-radius">
          <Slider
            min={0}
            max={100}
            value={this.state.radius}
            onChange={radius => {
              this.setState({ radius });
            }}
            onChangeComplete={this.setRadius}
          />
        </div>
        <b>{this.state.radius} Kilometer</b>
        <CategorySelect categories={ort.categories} onChange={this.setCategories} />
      </div>
    );
  }
}

EditOrt.propTypes = {
  setOrtRadius: PropTypes.func.isRequired,
  setOrtCategories: PropTypes.func.isRequired,
  ort: PropTypes.object.isRequired,
};

const mapStateToProps = (state, ownProps) => {
  const ort = state.orte.filter(item => item.name === ownProps.match.params.ort)[0];
  return {
    ort,
  };
};

const mapDispatchToProps = dispatch => ({
  setOrtRadius: (ort, value) => {
    dispatch(setOrtRadius(ort, value));
  },
  setOrtCategories: (ort, value) => {
    dispatch(setOrtCategories(ort, value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(EditOrt);



// WEBPACK FOOTER //
// ./src/js/routes/Orte/EditOrt.js